export const PROVIDER_SSAS = 'ssas';
export const PROVIDER_AUTH0 = 'auth0';
